export const adjustmentsContainerStyles = {
  display: 'flex',
  gap: '20px',
};

export const blockCustomStyles = {
  width: 'calc(50% - 20px)',
};

export const formPartCustomStyles = {
  ...blockCustomStyles,
  padding: '12px',
  marginTop: '48px',
  '& .divider': {
    marginBottom: '12px',
  },
};

export const controlsBlock = {
  marginTop: '36px',
};

export const getExtensionItemStyles = isActive => ({
  display: 'flex',
  justifyContent: 'space-between',
  borderRadius: '8px',
  padding: '12px',
  border: ({ palette }) => `1px solid ${isActive ? palette.primary.main : palette.border.default}`,
  cursor: 'pointer',

  '&:hover': {
    border: ({ palette }) => `1px solid ${palette.primary.main}`,
  },

  '& > div': {
    cursor: 'pointer',
  },
});

export const extensionItemsContainerStyles = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '24px',
  margin: '12px 0',
  paddingBottom: '12px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const dialogCustomStyles = {
  '& #confirmation-dialog-title': {
    textAlign: 'center',
  },
};
